import { useEffect, useState } from 'react'
import Button from '../../components/Button'
import { useNavigate } from 'react-router-dom';
import { AiFillEdit } from "react-icons/ai";
import { AiFillDelete } from "react-icons/ai";
import { useDispatch, useSelector } from 'react-redux';
import LoadMore from '../../components/common/LoadMore';
import useFirstRender from '../../hooks/FirstRender';
import { toast } from 'react-toastify';
import { ENTITY_IS_IN_USE_MESSAGE } from '../../utils/constants';
import { GoPlus } from "react-icons/go";
import { useApiProgress } from '../../hooks/ApiProgress';
import { pageModel } from '../../utils/model';
import { USER_PATH, deleteUser, getPageUsers } from '../../api/userApi';
import { formatDate } from '../../utils/functions';
import { translateRole } from '../../utils/translator';
import { RiLockPasswordFill } from "react-icons/ri";

const UserListPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const isFirstRender = useFirstRender()
    const nav = useNavigate()
    const dispatch = useDispatch()
    const [userPage, setUserPage] = useState(pageModel)
    const pendingApiCall = useApiProgress('get', `${USER_PATH}/page`, false)
    const pendingApiCallDelete = useApiProgress('delete', `${USER_PATH}`, false)
    const searchParams = useSelector(state => state.searchParams.user)
    const [isOpen, setIsOpen] = useState(false)
    const [deleteId, setDeleteId] = useState(undefined)
    const [searchTimer, setSearchTimer] = useState();

    useEffect(() => {
        loadUsers({ size: 20, page: userPage.number, ...searchParams })
    }, [])

    const onLoadMore = () => {
        if (!userPage.last) {
            loadUsers({ ...searchParams, page: userPage.number + 1 })
        }
    }

    useEffect(() => {
        !isFirstRender && searching({ ...searchParams, page: 0 })
    }, [searchParams])

    const loadUsers = (params) => {
        !pendingApiCall &&
            getPageUsers(params)
                .then(res => {
                    setUserPage(prevState => ({ ...res.data, content: [...prevState.content, ...res.data.content] }))
                })
    }

    const searching = async (params) => {
        if (searchTimer) clearTimeout(searchTimer);
        let timer = setTimeout(() => {
            getPageUsers(params)
                .then(res => {
                    setUserPage(res.data)
                })
        }, 500);
        setSearchTimer(timer);
    }

    const onClickDelete = () => {
        deleteUser(deleteId)
            .then(res => {
                setIsOpen(false)
                toast.success('Silindi')
            }).catch(err => {
                toast.error(ENTITY_IS_IN_USE_MESSAGE)
            })
    }

    return (
        <div>
            <div className='mb-1 border-b border-zinc-300'>
                <label className='text-2xl'>
                    KULLANICILAR
                </label>
            </div>
            <div className='flex gap-x-2 py-2 sticky top-0 bg-zinc-50'>
                <Button
                    text={<label className='flex items-center gap-x-1'><GoPlus />Yeni Kullanıcı</label>}
                    variant='green'
                    onClick={() => nav('/user/add')}
                />
            </div>
            <table className='w-full text-left text-zinc-900 mb-10 text-sm'>
                <thead className='text-xs uppercase tracking-wide sticky top-12 bg-zinc-50'>
                    <tr>
                        <th className='p-2 w-2/12'>Kullanıcı Adı</th>
                        <th className='p-2 w-3/12'>Ad Soyad</th>
                        <th className='p-2 w-2/12'>Rol</th>
                        <th className='p-2 w-2/12'>İşe Giriş Tarihi</th>
                        <th className='p-2 w-2/12'>Ayrılış Tarihi</th>
                        <th className='p-2 w-1/12'>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        userPage.content.map((user, index) => (
                            <tr key={user.id} className='border-b items-center hover:bg-violet-100 duration-150'>
                                <td className='p-2'>{user.username} </td>
                                <td className='p-2'>{user?.fullName}</td>
                                <td className='p-2'>{translateRole(user.role)}</td>
                                <td className='p-2'>{formatDate(user?.hireDate)}</td>
                                <td className='p-2 '>{formatDate(user?.exitDate)}</td>

                                <td className='p-2 items-center'>
                                    <div className='flex gap-x-3'>
                                        <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => nav(`/user/edit/${user.id}`)}>
                                            <AiFillEdit />
                                        </span>
                                        <span onClick={() => nav(`/user/edit-password/${user.id}`)}>
                                            <RiLockPasswordFill />
                                        </span>
                                        <span
                                            className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                            onClick={() => {
                                                setIsOpen(true)
                                                setDeleteId(user.id)
                                            }}
                                        >
                                            <AiFillDelete />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            <LoadMore page={userPage} pending={pendingApiCall} onLoadMore={onLoadMore} />
        </div>
    )
}

export default UserListPage
